/* eslint-disable */
/**
 * AfventerBadge — Amber puls til ventende beslutninger / handlinger
 *
 * Props:
 *   antal   number  — antal ventende (0 = skjult som standard)
 *   label   string  — tekst (default: "afventer")
 *   vis0    bool    — vis badge selv ved antal=0 (default: false)
 *   onClick fn
 *   style   obj
 */

import React from 'react';

const AMBER_BG   = 'rgba(245,158,11,0.14)';
const AMBER_KANT = 'rgba(245,158,11,0.35)';
const AMBER_TXT  = '#fbbf24';

export default function AfventerBadge({ antal, label = 'afventer', vis0 = false, onClick, style = {} }) {
  if (!vis0 && (antal == null || antal === 0)) return null;

  return (
    <span
      onClick={onClick}
      style={{
        display:      'inline-flex',
        alignItems:   'center',
        gap:          6,
        fontSize:     10,
        fontWeight:   700,
        padding:      '3px 9px',
        borderRadius: 20,
        background:   AMBER_BG,
        border:       `1px solid ${AMBER_KANT}`,
        color:        AMBER_TXT,
        textTransform: 'uppercase',
        letterSpacing: 0.7,
        cursor:       onClick ? 'pointer' : 'default',
        whiteSpace:   'nowrap',
        ...style,
      }}
    >
      {/* Puls-ring */}
      <span style={{
        width:        7,
        height:       7,
        borderRadius: '50%',
        background:   AMBER_TXT,
        display:      'inline-block',
        animation:    'puls-ring 1.4s ease-in-out infinite',
        flexShrink:   0,
      }} />
      {antal != null ? `${antal} ` : ''}{label}
    </span>
  );
}
